import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltMediaSourceSettingsDividerWireframe from '../VeltMediaSourceSettingsDividerWireframe/VeltMediaSourceSettingsDividerWireframe';
import VeltMediaSourceSettingsOptionsWireframe from '../VeltMediaSourceSettingsOptionsWireframe/VeltMediaSourceSettingsOptionsWireframe';
import VeltMediaSourceSettingsSelectedLabelWireframe from '../VeltMediaSourceSettingsSelectedLabelWireframe/VeltMediaSourceSettingsSelectedLabelWireframe';
import VeltMediaSourceSettingsToggleIconWireframe from '../VeltMediaSourceSettingsToggleIconWireframe/VeltMediaSourceSettingsToggleIconWireframe';
var VeltMediaSourceSettingsVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-video-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsVideoWireframe.ToggleIcon = VeltMediaSourceSettingsToggleIconWireframe;
VeltMediaSourceSettingsVideoWireframe.SelectedLabel = VeltMediaSourceSettingsSelectedLabelWireframe;
VeltMediaSourceSettingsVideoWireframe.Options = VeltMediaSourceSettingsOptionsWireframe;
VeltMediaSourceSettingsVideoWireframe.Divider = VeltMediaSourceSettingsDividerWireframe;
export default VeltMediaSourceSettingsVideoWireframe;
